import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/logo/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-dfbc6940"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "main flex_FCAC"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, "手机号", -1));
const _hoisted_6 = {
  key: 0,
  class: "item mt10"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label mb5"
}, "图形验证码", -1));
const _hoisted_8 = {
  key: 1,
  class: "item mt10"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label mb5"
}, "验证码", -1));
const _hoisted_10 = {
  key: 2,
  class: "item mt10"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label mb5"
}, "密码", -1));
const _hoisted_12 = {
  class: "checkbox flex_FCAC"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml5"
}, " 首次登录注册九运易合账号，且已阅读并同意", -1));
const _hoisted_14 = {
  class: "img_box"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_link = _resolveComponent("el-link");
  const _component_Protocol = _resolveComponent("Protocol");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
    class: "mt5",
    modelValue: $setup.data.phone,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.phone = $event),
    type: "tel",
    size: "large",
    maxlength: 11,
    placeholder: "请输入手机号码"
  }, null, 8, ["modelValue"])]), $setup.data.tabsIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
    modelValue: $setup.data.validation,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.data.validation = $event),
    type: "tel",
    size: "large",
    maxlength: 4,
    placeholder: "请输入图形验证码"
  }, {
    suffix: _withCtx(() => [_createVNode(_component_el_image, {
      class: "pointer",
      src: 'data:image/png;base64,' + $setup.data.captcha.base,
      onClick: $setup.generateCaptcha,
      fit: "contain"
    }, null, 8, ["src", "onClick"])]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true), $setup.data.tabsIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_input, {
    modelValue: $setup.data.code,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.code = $event),
    size: "large",
    maxlength: 6,
    placeholder: "请输入验证码"
  }, {
    suffix: _withCtx(() => [_createVNode(_component_el_button, {
      style: {
        "margin-left": "0.7vw"
      },
      type: "primary",
      size: "large",
      loading: $setup.data.codeLoading,
      link: "",
      disabled: Boolean($setup.data.second) || !$setup.data.validation,
      onClick: $setup.sendCode
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.second ? `${$setup.data.second}s后获取` : "获取验证码"), 1)]),
      _: 1
    }, 8, ["loading", "disabled", "onClick"])]),
    _: 1
  }, 8, ["modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_input, {
    modelValue: $setup.data.password,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.data.password = $event),
    size: "large",
    "show-password": "",
    type: "password",
    placeholder: "请输入密码"
  }, null, 8, ["modelValue"])])), _createElementVNode("div", {
    class: "login_btn pointer",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.login && $setup.login(...args))
  }, "登录"), _createElementVNode("div", {
    class: "change_btn pointer",
    onClick: _cache[5] || (_cache[5] = () => $setup.changeTabIndex($setup.data.tabsIndex ? 0 : 1))
  }, _toDisplayString($setup.data.tabsIndex ? "验证码登录" : "密码登录"), 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_checkbox, {
    modelValue: $setup.data.isReadProtocol1,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.data.isReadProtocol1 = $event),
    size: "large",
    onChange: _cache[7] || (_cache[7] = value => $setup.setIsReadProtocol(value, 'isReadProtocol1'))
  }, null, 8, ["modelValue"]), _hoisted_13, _createVNode(_component_el_link, {
    type: "primary",
    onClick: _cache[8] || (_cache[8] = () => $setup.setProtocolUrl('https://jyyh.net/protocol/index.html?keyword=UPN_consigner'))
  }, {
    default: _withCtx(() => [_createTextVNode("《用户注册协议》")]),
    _: 1
  }), _createVNode(_component_el_link, {
    type: "primary",
    onClick: _cache[9] || (_cache[9] = () => $setup.setProtocolUrl('https://jyyh.net/protocol/index.html?keyword=PP_consigner'))
  }, {
    default: _withCtx(() => [_createTextVNode("《用户隐私政策》")]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$setup.data.imgList1, $setup.data.imgList2, $setup.data.imgList, $setup.data.imgList3, $setup.data.imgList4, $setup.data.imgList1], (list, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, item => {
      return _openBlock(), _createElementBlock("img", {
        key: item,
        src: item,
        alt: ""
      }, null, 8, _hoisted_15);
    }), 128))]);
  }), 128))])]), _createVNode(_component_el_dialog, {
    style: {
      "width": "85vw"
    },
    top: "0",
    modelValue: $setup.data.protocolVisible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $setup.data.protocolVisible = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_Protocol, {
      url: $setup.data.protocolUrl
    }, null, 8, ["url"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}